// extracted by mini-css-extract-plugin
export default {"link":"LinkOut_link__CyiAz"};